/* eslint-disable eqeqeq */
import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import { Spin } from "antd";
import Cookies from "js-cookie";
import { changeLang } from "../../../actions/langAction";
import { setDynamic } from "../../../actions/dynamicAction";
import Api from "../../../services/ServiceApi";
/* component */
import LayoutOperation from "../../../components/LayoutOperationBBtec";
import OnprocessDetail from "./onprocessdetail/OnprocessDetail";
import { HandleFormContext, AuthContext } from "../../../contexts";

function Controller(props) {
  const {
    company_id: CompanyId,
    operator_id: OperatorId,
    project_id: ProjectId,
    job_id,
  } = useParams();
  const ProjectData = JSON.parse(localStorage.getItem("projectData"))?.filter(
    (data) => {
      return (
        data.operator_id == OperatorId &&
        data.company_id == CompanyId &&
        data.project_id == ProjectId
      );
    }
  );

  /* state */
  const { LangTranslate, factUpdate, layout } = props;
  console.log("layoutController", layout);
  // const [factUpdate, setfactUpdate] = useState(false);
  // const [LangTranslate, setLangTranslate] = useState([]);
  const [detailData, setdetailData] = useState({});
  /* workflow */
  const [workflowJob, setworkflowJob] = useState([]);
  /* fulldetail */
  const [Fulldetail, setFulldetail] = useState({});

  const [CallDataSuccess, setCallDataSuccess] = useState(false);
  const unmounted = useRef(false);

  useEffect(() => {
    Cookies.set("project_id", ProjectId);
    /* call workflow */
    async function FetchData() {
      Api.post("job_detail/get_job_detail", {
        job_id: job_id,
        company_id: CompanyId,
        operator_id: OperatorId,
        project_id: ProjectId,
      }).then((res) => {
        if (res.data.data.job_detail[0]) {
          const dataTocall = res.data.data.job_detail[0];
          setdetailData(dataTocall);
          Api.post("getButtonDetailWeb", {
            ActionID: 1,
            CompanyID: CompanyId,
            JobTypeID: dataTocall.job_type_id,
            MainProcessID: dataTocall.main_process_id,
            ProjectID: ProjectId,
            SubProcessID: dataTocall.subprocessid,
            UserName: Cookies.get("username"),
            Version: 1,
            WF_ID: 0,
            operator_id: OperatorId,
          })
            .then((res) => {
              setworkflowJob(res.data.return_nextWorkFlow);
            })
            .catch((e) => {
              console.log(e);
            });

          Api.post("job_detail/get_job_fulldetail", {
            company_id: CompanyId,
            operator_id: OperatorId,
            project_id: ProjectId,
            job_id: job_id,
            job_progress_id: dataTocall.job_progress_id,
          })
            .then((res) => {
              setFulldetail(res.data.data);
              setCallDataSuccess(true);
            })
            .catch((e) => {
              console.log(e);
            });
        }
      });
    }
    FetchData();
    return () => {
      unmounted.current = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  /* for debug */
  return (
    <>
      <AuthContext>
        <HandleFormContext>
          <LayoutOperation key={`onprocess_detail`} layout={layout}>
            <Spin
              spinning={!CallDataSuccess}
              size="large"
              style={{ marginTop: "30%" }}
            >
              {CallDataSuccess ? (
                <OnprocessDetail
                  CompanyId={CompanyId}
                  OperatorId={OperatorId}
                  ProjectId={ProjectId}
                  ProjectData={ProjectData}
                  headerdata={detailData}
                  Jobdata={Fulldetail ? Fulldetail : null}
                  Workflowdata={workflowJob ? workflowJob : null}
                  factUpdate={factUpdate ? factUpdate : null}
                  LangTranslate={LangTranslate ? LangTranslate : null}
                />
              ) : null}
            </Spin>
          </LayoutOperation>
        </HandleFormContext>
      </AuthContext>
    </>
  );
}

const mapStateToProps = (state) => ({
  lang: state.lang,
  dynamicReducer: state.dynamicReducer,
  LangTranslate: state.masterLang.masterLang,
  factUpdate: state.masterLang.factUpdate,
  layout: "position-fixed-not",
});
const mapDispacthToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLang(data)),
    setDynamic: (data, visible) => dispatch(setDynamic(data, visible)),
  };
};
export default connect(mapStateToProps, mapDispacthToProps)(Controller);
